export default "__VITE_ASSET__Buwdhy_G__"